import React from "react";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import LogoStrip from "../components/site/LogoStrip";
import Philosophy from "../components/site/Philosophy";
import Services from "../components/site/Services";
import Process from "../components/site/Process";
import CaseStudies from "../components/site/CaseStudies";
import Testimonials from "../components/site/Testimonials";
import Founders from "../components/site/Founders";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="font-body bg-[var(--lt-peace)]">
      <Nav />
      <Hero />
      <LogoStrip />
      <Philosophy />
      <Services />
      <Process />
      <CaseStudies />
      <Testimonials />
      <Founders />
      <Contact />
      <Footer />
    </main>
  );
};

export default Landing;
